<template>
<div>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
            <v-flex xs12>
                <div>
                    <v-layout row wrap fill-height class="pa-2 header">
                        <v-flex xs12 sm3 md2>
                            <div class="title text-color">Registrations</div>
                        </v-flex>
                        <v-flex xs12 sm9 md10 class="filter_form">
                            <v-form @submit.prevent="validateBeforeSubmit('filterList')" data-vv-scope="filterList" id="filterList" ref="form">
                                <v-layout row wrap>
                                    <v-flex xs6 sm4 md3>
                                        <v-text-field name="Name" 
                                        label="Search By Name" 
                                        id="name" 
                                        regular
                                        single-line 
                                        v-model="filters.name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm4 md2>
                                        <v-menu v-model="from_menu" 
                                        :close-on-content-click="false" 
                                        transition="scale-transition" 
                                        :nudge-right="40" 
                                        offset-y max-width="290px"
                                         min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field label="From Date" 
                                                readonly v-on="on" 
                                                regular single-line
                                                name="From Date" 
                                                v-model="filters.from_date"
                                                :error-messages="errors.collect('filterList.From Date')">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker 
                                            v-if="from_menu" 
                                            v-model="filters.from_date"
                                            @input="from_menu = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12 sm4 md2>
                                        <v-menu v-model="to_menu" 
                                        :close-on-content-click="false" 
                                        transition="scale-transition"
                                         :nudge-right="40"
                                         offset-y max-width="290px"
                                          min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field 
                                                label="To Date"
                                                 readonly v-on="on" 
                                                 regular single-line 
                                                 name="To Date"
                                                  v-model="filters.till_date" 
                                                  :error-messages="errors.collect('filterList.To Date')">
                                                  </v-text-field>
                                            </template>
                                            <v-date-picker v-if="to_menu" 
                                            :min="this.filters.from_date"
                                             v-model="filters.till_date" 
                                             @input="to_menu = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs6 sm5 md3 class='buttoncenter pl-5'>
                                        <v-btn small color="primary" type="submit">Apply</v-btn>
                                        <v-btn small color="primary" class="btn_reset ml-1" @click="resetFilter">Reset</v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm2 md2>
                                        <v-btn small class="float_right" color="primary" to="addRegistration">Register</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex sm12 md12>
                            <v-data-table 
                             :headers="headers"
                             :items="registrations" 
                             item-key="id" 
                             class="elevation-1" 
                             :loading="is_loading" 
                             :options.sync="options" 
                             :server-items-length="total_items" 
                             :footer-props="{'items-per-page-options': [15,20,40,80]}" 
                             :items-per-page="15"
                              no-results-text="Loading... Please wait">
                                <template v-slot:body="{ items }" v-if="!is_loading && total_items!='0'">
                                    <tbody>
                                        <tr v-for="item in items" :key="item.id">
                                            <td v-if="item.record">
                                                <router-link :to="{ name:'showRegistrationDetails',params: { id:item.id } }">{{ item.record.name|capitalize }}
                                                </router-link>
                                            </td>
                                            <td v-else>-</td>
                                            <td v-if="item.purpose">{{ item.purpose |capitalize}}</td><td v-else>-</td>
                                            <td v-if="item.from_date">{{formatDate(item.from_date)}}</td><td v-else>-</td>

                                            <!-- <td v-show="role!='Office Admin'">{{formatDateTime(item.to_date)}}</td> -->
                                            <td v-if="item.to_date">{{formatDate(item.to_date)}}</td><td v-else>-</td>
                                            <td v-if="item.status" v-bind:class="getClass(item.status)">{{ item.status |capitalize}}</td><td v-else>-</td>
                                            <td v-if="item.created_at">{{ formatDate(item.created_at) }}</td><td v-else>-</td>

                                            <td v-show="role=='Super Admin'">{{ item.type |capitalize}}</td>
                                            <td v-if="item.office !=null" v-show="role=='Super Admin'">
                                                <router-link :to="{ name:'showOfficeDetails',params: { id:item.office.id } }">{{ item.office.name }}
                                                </router-link>
                                            </td>
                                            <td v-else v-show="role=='Super Admin'">-</td>
                                             
                                            <td >
                                                <v-btn text icon color="primary" :to="`registrations/edit/${item.id}`" :disabled="isDisabled(item.from_date)">
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                                <template v-slot:loading> Loading... Please wait </template>
                             <template v-slot:no-results> No data available </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </div>

            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
// import moment from "moment";
export default {
    watch: {
        options: {
            handler() {
                this.getList();
            }
        }
    },
    methods: {
      
      isDisabled:function(from_date) {
          var current_date = moment().format('YYYY-MM-DD');
          var date = moment(from_date).format('YYYY-MM-DD');
    return date<current_date;
       
      },
    
        getList: function () {
            this.is_loading = true;
            this.options.filters = Object.assign({}, this.filters);

            axios.get(`${process.env.VUE_APP_API_URL}/api/registrations`, {
                params: this.options
            }).then((response) => {
                if (response.data.status == 1) {
                   
                    this.registrations = response.data.registrations_list.data;
                    this.total_items = response.data.registrations_list.total;
                    
                    this.registration_count = response.data.registration_count;

                    this.is_loading = false;

                }
            }).catch((error) => {
                console.log(error);

            }).finally(() => {
                {

                }
            });

        },
       
        deleteRegistration: function (registration) {
            this.to_be_deleted_registration = registration;
            this.delete_registration_dialog_box = true;
        },
        confirmDeleteRegistration: function () {
            axios
                .post(`${process.env.VUE_APP_API_URL}/api/registrations/` + this.to_be_deleted_registration.id + `/delete`).then((response) => {
                    if (response.data.status == 1) {
                        this.response_message = response.data.message;
                        this.delete_registration_dialog_box = false;
                        this.getList();
                    }

                }).catch((error) => {
                    console.log(error);

                }).finally(() => {
                    {

                    }
                });
        },
        validateBeforeSubmit: function (scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this[scope]();
                }
            });
        },
        filterList() {
            let filter_values = Object.values(this.filters);
            if (filter_values.join('').length > 0) {
                this.$router.replace({
                    name: "registrations",
                    query: {
                        filters: true,
                        name: this.filters.name,
                        from_date: this.filters.from_date,
                        till_date: this.filters.till_date,

                    }
                });
                this.displayFilterChips(this.filters);
                this.is_filtered = true;
            } else {
                this.$router.replace({
                    name: "registrations"
                });
            }
            this.getList();
            this.filter_dialog_box = false;
        },
        clearFilter: function (filter, key) {
            this.filter_chips[key] = this.filters[key] = '';
            this.filterList();
        },
        resetFilter() {
            this.$router.replace({
                name: 'registrations',
                query: {}
            });
            this.getList();
            this.resetFiltersParameters();
            this.is_filtered = false;
            this.filter_dialog_box = false;
        },
        resetFiltersParameters: function () {
            for (var key in this.filters) {
                this.filters[key] = '';
                this.filter_chips[key] = '';
            }
        },
        applyFiltersOnLoad: function () {
            this.filters.name = this.$route.query.name;
            this.filters.from_date = this.$route.query.from_date;
            this.filters.till_date = this.$route.query.till_date;
            this.displayFilterChips(this.filters);
        },
        displayFilterChips: function (filters) {
            if (this.$route.query.filters) {
                this.filter_chips.name = filters.name;
                this.filter_chips.from_date = filters.from_date;
                this.filter_chips.till_date = filters.till_date;
                this.is_filtered = true;
            }
        },
        getClass(status) {
            if (status == 'approved') return 'text-green';
            else if (status == 'pending') return 'text-red';
            else if (status == 'rejected') return 'text-orange';
        },
        applycolumnfilter: function () {

            if (this.role == 'Super Admin') {
                this.headers = [{
                        text: 'Visitor Name',
                        align: 'left',
                        value: 'record.name',
                        sortable: true
                    },
                    {
                        text: 'Purpose',
                        value: 'purpose',
                        sortable: false
                    },
                    {
                        text: 'From Date',
                        value: 'from_date',
                        sortable: false
                        
                    },
                    {
                        text: 'To Date',
                        value: 'to_date',
                        sortable: false
                    },
                    {
                        text: 'Status',
                        value: 'status',
                        sortable: false
                    },
                    {
                        text: 'Created On',
                        value: 'created_on',
                        sortable: false
                    },
                    {
                        text: 'Type',
                        value: 'type',
                        sortable: false
                    },
                    {
                        text: 'Office',
                        value: 'office',
                        sortable: false
                    },
                   
                    {
                        text: 'Action',
                        value: '',
                        sortable: false
                    },
                ];
            }
            if (this.role == 'Office Admin') {
                this.headers = [{
                        text: 'Visitor Name',
                        align: 'left',
                        value: 'name',
                        sortable: false
                    },
                    {
                        text: 'Purpose',
                        value: 'purpose',
                        sortable: false
                    },
                    {
                        text: 'From date',
                        value: 'from_date',
                        sortable: false
                    },
                    {
                        text: 'To date',
                        value: 'to_date',
                        sortable: false
                    },
                    {
                        text: 'Status',
                        value: 'status',
                        sortable: false
                    },
                    {
                        text: 'Created On',
                        value: 'created_on',
                        sortable: false
                    },
                    
                    {
                        text: 'Action',
                        value: '',
                        sortable: false
                    },
                ];
            }
            if (this.role == 'Society Admin') {
                this.headers = [{
                        text: 'Visitor Name',
                        align: 'left',
                        value: 'name',
                        sortable:false
                    },
                    {
                        text: 'Purpose',
                        value: 'purpose',
                        sortable: false
                    },
                    {
                        text: 'From date',
                        value: 'from_date',
                        sortable: false
                    },
                    {
                        text: 'To date',
                        value: 'to_date',
                        sortable: false
                    },
                    {
                        text: 'Status',
                        value: 'status',
                        sortable: false
                    },
                    {
                        text: 'Created On',
                        value: 'created_on',
                        sortable: false
                    },
                    
                    {
                        text: 'Action',
                        value: '',
                        sortable: false
                    },
                ];
            }
        }
    },
    data() {
        return {
            createdby: '',
            options: {},
            total_items: 10,
            headers: [],
            role: '',
            office: [],
            registrations: [],
            visitor: [],
            creator: [],
            registration_count:'1',
            filter_dialog_box: false,
            filters: {
                name: '',
                from_date: '',
                till_date: '',
            },
            filter_chips: {
                name: '',
                from_date: '',
                till_date: '',
            },
            is_loading: false,

            from_date_menu: false,
            to_date_menu: false,
            from_menu: false,
            to_menu: false,

            is_filtered: false,
            registration_disable:false,

            to_be_deleted_registration: {},
            delete_registration_dialog_box: false,
        }
    },
    mounted() {
        this.role = localStorage.getItem('visitor_management_role');
        this.applycolumnfilter();
        this.applyFiltersOnLoad();

    },
};
</script>
